<template>
  <div class="c-card">
    <div class="c-card__pill">submission</div>
    <div class="c-card__liner">
      <div class="c-card__content">
        <div class="c-card__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="39"
            viewBox="0 0 31 39"
            fill="none"
          >
            <path
              d="M9.03898 10.8484H21.9618M9.03898 17.4109H21.9618M9.03898 23.9734H15.5004M5.80777 2.09839H25.1924C27.5715 2.09839 29.5 4.05719 29.5 6.47347L29.4995 32.7235C29.4995 35.1397 27.5709 37.0984 25.1919 37.0984L5.80759 37.0983C3.42856 37.0983 1.49998 35.1395 1.5 32.7233L1.50017 6.47337C1.50018 4.05713 3.42876 2.09839 5.80777 2.09839Z"
              stroke="#05271D"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="c-card__details">
          <h3 class="c-card__title c-card__title--includes-extension">
            <a :href="result.link" target="_blank">
              {{ result.title }}
            </a>
            <a
              :href="result.link"
              target="_blank"
              v-show="result.extension"
              class="c-card__file-extension"
            >
              <span class="c-card__file-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="37"
                  viewBox="0 0 36 37"
                  fill="none"
                >
                  <path
                    d="M6 30.6725C6.60706 31.2653 7.43041 31.5984 8.28892 31.5984H27.7111C28.5696 31.5984 29.3929 31.2653 30 30.6725M18.0018 4.59839V22.5121M18.0018 22.5121L25.4007 15.6673M18.0018 22.5121L10.6029 15.6673"
                    stroke="#05271D"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              {{ result.extension }}
              <span class="c-card__filesize">({{ result.filesize }})</span>
            </a>
          </h3>

          <div class="c-card__description u-content">
            {{ result.description }}
          </div> 

          <div class="c-card__date">{{ result.documentDate }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    result: Object,
  },
  components: {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>
<style lang="scss"></style>
